export default __webpack_public_path__ + "static/media/logo-ovato-privacy-policy-new.6cc16047.png";